
import './InfoCard.css'
export default function InfoCard(props){
    const bgImgStyle = {
        backgroundImage: `url(${props.bgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    }
    return (
        <div className='info-card-wrapper'>
            <div className='info-card back'>
                <h1>{props.subtitle}</h1>
                <ul>
                    {props.description && props.description.map((line, ind) => <li key={ind}>{line}</li>)}
                </ul>
            </div>
            <div style={bgImgStyle} className='info-card front'>
                <h2 className='title'>{props.title}</h2>
            </div>
        </div>
    )
}